var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    id: "upload",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filled_Icons_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filled_Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.852,6.332C16.611,3.994,14.152,2.5,11.5,2.5c-3.618,0-6.648,2.693-7.123,6.227C2.012,8.547-0.001,10.451,0,12.803 C0,16.076,2.825,16.979,4.326,17H10v-2.382c0,0-0.436,0.438-0.439,0.442c-0.586,0.586-1.537,0.586-2.123,0 c-0.585-0.585-0.585-1.535,0.001-2.121l3.001-3.003c0.56-0.56,1.564-0.559,2.124,0.004c0,0,2.995,2.999,2.996,2.999 c0.586,0.586,0.586,1.536,0.001,2.121c-0.586,0.586-1.537,0.586-2.123,0C13.436,15.057,13,14.618,13,14.618V17h5.271 C18.319,16.992,23,16.205,23,11.607C23,8.74,20.702,6.399,17.852,6.332z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.146,14.351c0.001,0.002,0.002,0.002,0.002,0.002c0.192,0.189,0.512,0.189,0.703,0c0,0,0.002,0,0.002-0.002L11,12.204 V22c0,0.276,0.225,0.5,0.5,0.5c0.276,0,0.5-0.224,0.5-0.5v-9.796l2.146,2.147c0.19,0.19,0.506,0.201,0.707,0 c0.197-0.197,0.193-0.514,0-0.707l-2.998-2.998c-0.191-0.191-0.515-0.195-0.708-0.002l-3.001,3 C7.951,13.839,7.951,14.155,8.146,14.351z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "New_icons"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Invisible_Shape"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 24,
    height: 24
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.55522632b2fc9b7004e005b966328e71.svg";
export { ForwardRef as ReactComponent };